export default __webpack_public_path__ + "static/2384-da3840a580de9e7b3e7b6f7ab967c75f.gif";